export enum AuthenticationStatus {
  NotAuthenticated = 'NotAuthenticated',
  Authenticating = 'Authenticating',
  Authenticated = 'Authenticated',
  Error = 'Error'
}
